import { render, staticRenderFns } from "./NewProfile.vue?vue&type=template&id=6110cd4e&"
import script from "./NewProfile.vue?vue&type=script&lang=ts&"
export * from "./NewProfile.vue?vue&type=script&lang=ts&"
import style0 from "./NewProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports